module.exports = __webpack_public_path__ + "media/images/pc/brands/tvb/store_hiroshima-7690e33cd6687ea102da32e8b9ecb294.jpg";